// Packages:
import React, { memo } from "react";
import {  useSelector } from "react-redux";

// Styles:
import { Body, Description, Field, NodeLabel, NodeWrapper, StyledHandle } from "../styles";
import BaseNode from "../BaseNode";
import { config } from "./config";
import useNodeStyles from "../../../../hooks/useNodeStyles";
// Functions:
const LogisticsNode = ({ data }) => {
  // Constants:
  const {id,label,userId } = data;

  const { studio, isSelected } = useSelector((state) => ({
    studio: state.studio,
    isSelected: state.studio.selectedNode?.id === id,
  }));

  const {computedLabelStyle,computedBodyStyle,computedWrapperStyle}=useNodeStyles({isSelected,config})


  // Return:
  return (
    <BaseNode data={data} config={config}>
      <NodeWrapper style={computedWrapperStyle} backgroundColor={'#FEFFFE'} borderColor={'#7A5980'}>
      {config.handleStyles.map((handle, index) => (
        <StyledHandle
            key={index}
            id={handle.properties.id}
            type={handle.properties.type}
            position={handle.properties.position}
            style={handle.style}
        />
        ))}
        <NodeLabel htmlFor="text" style={computedLabelStyle}>
          {label}
        </NodeLabel>
        <Body style={computedBodyStyle}>
        <Description>
          <Field isActive={studio.selectedNode?.id === id} activeColor={'#B74A01'} inActiveColor={'#FE7920'}>
            {!userId ? (
              <span style={{ fontStyle: 'italic', fontWeight: 400 }}>
                User Id
              </span>
            ) : (
              userId?.value?.fieldName ?? userId?.value?.value
            )}
          </Field>
        </Description>
      </Body>
      </NodeWrapper>
    </BaseNode>
  );
};

// Exports:
export default memo(LogisticsNode);